import {
  IBackgroundColorConfiguration, instanceOfIBackgroundColorConfiguration,
  IBorderColorConfiguration, instanceOfIBorderColorConfiguration, IEnableConfiguration,
} from "../../../../domain/configuration";
import {
  Color,
  TextureKinds,
  PaintStyle,
  BorderStyle,
} from "../../../../domain/drawing";
import {
  IItem,
} from "../../../../domain/document/items";
import { IObjectStyleReadable } from "../IObjectStyleReadable";

export abstract class AbstractObjectStyleReader<T extends IItem> implements IObjectStyleReadable {
  readPaintStyle(source: IItem, shouldInputFree: boolean): PaintStyle {
    const specifiedStyle = this.readSpecifiedPaintStyle(source as T, shouldInputFree);
    return specifiedStyle
      ? specifiedStyle
      : this.readDefaultPaintStyle(source, shouldInputFree);
  }

  protected abstract readSpecifiedPaintStyle(source: T, shouldInputFree: boolean): PaintStyle;

  private readDefaultPaintStyle(source: IItem, shouldInputFree: boolean): PaintStyle {
    const configuration = this.readBackgroundColorConfiguration(source as T, shouldInputFree);
    return this.toFillStyle(
      instanceOfIBackgroundColorConfiguration(configuration)
        ? new Color(configuration.backgroundColor)
        : null
    );
  }

  protected abstract readBackgroundColorConfiguration(source: T, shouldInputFree: boolean): IBackgroundColorConfiguration;

  private toFillStyle(color: Color): PaintStyle {
    return new PaintStyle(color, TextureKinds.Fill);
  }

  readBorderStyle(source: IItem, shouldInputFree: boolean): BorderStyle {
    const configuration = this.readBorderColorConfiguration(source as T, shouldInputFree);
    return this.toBorderStyle(
      instanceOfIBorderColorConfiguration(configuration)
        ? new Color(configuration.borderColor)
        : null
    );
  }

  protected abstract readBorderColorConfiguration(source: T, shouldInputFree: boolean): IBorderColorConfiguration;

  private toBorderStyle(color: Color): BorderStyle {
    return new BorderStyle(color, 1);
  }

  protected abstract readForegroundDisplayConfiguration(): IEnableConfiguration;

  isForegroundDrawingEnabled(): boolean {
    const configuration = this.readForegroundDisplayConfiguration();
    return configuration
      ? configuration.isEnable
      : false;
  }
}
